
import { supabase } from "@/integrations/supabase/client";

/**
 * Get quiz results for a campaign
 */
export const getCampaignQuizResults = async (campaignId: string): Promise<any[]> => {
  const { data, error } = await supabase
    .from('modal_campaign_user_quiz_results')
    .select('*')
    .eq('campaign_id', campaignId)
    .order('completed_at', { ascending: false });

  if (error) {
    console.error('Error fetching campaign quiz results:', error);
    throw error;
  }

  return data;
};

/**
 * Submit a user's quiz results
 */
export const submitQuizResult = async (
  campaignId: string,
  userId: string,
  logId: string,
  score: number,
  passed: boolean,
  attemptNumber: number,
  answers: Record<string, string[]>
): Promise<any> => {
  const { data, error } = await supabase
    .from('modal_campaign_user_quiz_results')
    .insert({
      campaign_id: campaignId,
      user_id: userId,
      log_id: logId,
      score: score,
      passed: passed,
      attempt_number: attemptNumber,
      answers: answers,
      completed_at: new Date().toISOString()
    })
    .select()
    .single();

  if (error) {
    console.error('Error submitting quiz result:', error);
    throw error;
  }

  return data;
};

/**
 * Record quiz attempt (alias for submitQuizResult) 
 */
export const recordQuizAttempt = async (
  logId: string,
  campaignId: string, 
  userId: string,
  score: number,
  passed: boolean,
  attemptNumber: number,
  answers: Record<string, string[]>
): Promise<any> => {
  return submitQuizResult(
    campaignId,
    userId,
    logId,
    score,
    passed,
    attemptNumber,
    answers
  );
};

/**
 * Get the number of previous attempts for a user on a campaign
 */
export const getPreviousAttempts = async (campaignId: string, userId: string): Promise<number> => {
  try {
    const { data, error } = await supabase
      .from('modal_campaign_user_quiz_results')
      .select('attempt_number')
      .eq('campaign_id', campaignId)
      .eq('user_id', userId)
      .order('attempt_number', { ascending: false })
      .limit(1);
    
    if (error) {
      console.error('Error fetching previous attempts:', error);
      return 0;
    }
    
    // If there are results, return the last attempt number, otherwise return 0
    return data && data.length > 0 ? data[0].attempt_number : 0;
  } catch (error) {
    console.error('Error in getPreviousAttempts:', error);
    return 0;
  }
};
